if not App.angularApp?
    return

###
 * mf-uc-words
 *
 * takes string, uppercases words like php's ucwords
 *
###
App.angularApp.filter 'mfUcWords', () ->
    return (input) =>
        if input
            words = input.split(/[\s_]+/)
            for v, k in words
                words[k] = v.substring(0, 1).toUpperCase() + v.substring(1)

            return words.join(' ')
